<template>
    <div
        class="container-fluid weflix-admin-collection page-card collection-detail-page"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <header class="collection-detail-header">
            <div class="collection-detail-header__lead">
                <div class="collection-detail-title-wrap">
                    <TitlePage
                        :title="currentCollections?.comercialName || 'Coleção'"
                        :subtitle="collectionSubtitlePlain"
                        :hasMargin="false"
                    />
                    <v-chip
                        v-if="currentCollections"
                        :color="
                            currentCollections.status == 1 ? 'success' : 'error'
                        "
                        size="small"
                        class="collection-detail-status-chip"
                    >
                        {{
                            currentCollections.status == 1
                                ? 'Ativo'
                                : 'Inativo'
                        }}
                    </v-chip>
                </div>
            </div>
            <div class="collection-detail-header__actions">
                <v-btn
                    variant="outlined"
                    color="primary"
                    rounded="lg"
                    border="2"
                    title="Editar coleção"
                    :icon="$vuetify.display.xs"
                    class="text-none collection-detail-header-btn"
                    @click="
                        () =>
                            $router.push(
                                `/admin/editar-colecao/${$route.params.slug}`
                            )
                    "
                >
                    <template v-if="$vuetify.display.xs">
                        <v-icon>mdi-lead-pencil</v-icon>
                    </template>
                    <template v-else>
                        <v-icon class="me-1" size="small"
                            >mdi-lead-pencil</v-icon
                        >
                        Editar coleção
                    </template>
                </v-btn>
                <v-btn
                    variant="flat"
                    color="primary"
                    rounded="lg"
                    title="Criar novo vídeo"
                    :icon="$vuetify.display.xs"
                    class="text-none collection-detail-header-btn collection-detail-header-btn--primary"
                    @click="() => $router.push('/admin/novo-video')"
                >
                    <template v-if="$vuetify.display.xs">
                        <v-icon>mdi-plus</v-icon>
                    </template>
                    <template v-else>
                        <v-icon class="me-1" size="small">mdi-plus</v-icon>
                        Novo vídeo
                    </template>
                </v-btn>
            </div>
        </header>

        <div class="collection-detail-shell">
            <section class="collection-detail-stats" aria-label="Resumo">
                <article class="collection-detail-stat-card">
                    <div
                        class="collection-detail-stat-card__icon"
                        aria-hidden="true"
                    >
                        <fa icon="fa-film" />
                    </div>
                    <div class="collection-detail-stat-card__body">
                        <span class="collection-detail-stat-card__label"
                            >Vídeos</span
                        >
                        <strong class="collection-detail-stat-card__value">{{
                            totalVideos
                        }}</strong>
                    </div>
                </article>
                <article class="collection-detail-stat-card">
                    <div
                        class="collection-detail-stat-card__icon"
                        aria-hidden="true"
                    >
                        <fa icon="fa-clock" />
                    </div>
                    <div class="collection-detail-stat-card__body">
                        <span class="collection-detail-stat-card__label"
                            >Tempo total</span
                        >
                        <strong class="collection-detail-stat-card__value">{{
                            totalMinutes
                        }}</strong>
                    </div>
                </article>
                <article class="collection-detail-stat-card">
                    <div
                        class="collection-detail-stat-card__icon"
                        aria-hidden="true"
                    >
                        <fa icon="fa-eye" />
                    </div>
                    <div class="collection-detail-stat-card__body">
                        <span class="collection-detail-stat-card__label"
                            >Visualizações</span
                        >
                        <strong class="collection-detail-stat-card__value">{{
                            totalViews
                        }}</strong>
                    </div>
                </article>
            </section>

            <div class="collection-detail-list-panel">
                <div class="orderVideos collection-detail-order-hint">
                    <small
                        >Segure o ícone pontilhado para arrastar os vídeos e
                        alterar a ordem.</small
                    >
                </div>

                <draggable
                    class="row g-3"
                    v-model="videos"
                    v-show="hasReady"
                    @end="onDragEnd"
                    :animation="200"
                    item-key="id"
                    handle=".drag-handle"
                    :group="{ name: 'videos' }"
                    :options="{
                        animation: 200,
                        ghostClass: 'ghost',
                        dragClass: 'drag',
                    }"
                >
                    <template #item="{ element }">
                        <div
                            class="col-12 col-sm-6 col-md-4 col-lg-3"
                            :key="element.id"
                        >
                            <div
                                class="itemCollectionVideo"
                                @click="editVideo(element.id)"
                            >
                                <div class="itemCollectionVideo-content">
                                    <div class="drag-handle">
                                        <fa icon="fa-grip-vertical" />
                                    </div>

                                    <p>
                                        {{ element.title }} -
                                        {{
                                            element.videoTime
                                                ? converterTempo(
                                                      element.videoTime
                                                  )
                                                : '00:00'
                                        }}
                                    </p>
                                    <!-- <div class="video-options">
                            <button class="options-btn" @click.stop="showOptions(element)">
                                <fa icon="fa-ellipsis-vertical"/>
                            </button>
                            <div v-if="element.showOptionsMenu" class="options-menu">
                                <div class="option-item" @click.stop="openMoveDialog(element)">
                                    Mover
                                </div>
                            </div>
                        </div>  -->
                                </div>

                                <div class="itemCollectionVideo-actions">
                                    <img
                                        :src="element.finalVideoThumbnail"
                                        alt=""
                                    />
                                    <div class="video-overlay">
                                        <fa
                                            icon="fa-pen-to-square"
                                            class="video-overlay-icon"
                                            title="Editar vídeo"
                                        />
                                    </div>
                                </div>
                                <span
                                    class="video-status"
                                    :class="getStatusClass(element.status)"
                                >
                                    {{ getStatusText(element.status) }}
                                </span>
                            </div>
                        </div>
                    </template>
                </draggable>

                <div
                    class="noVideos collection-detail-no-videos"
                    v-if="videos?.length === 0 && hasReady"
                >
                    <p>
                        Envie novos vídeos para esta coleção clicando aqui
                        <fa
                            icon="fa-plus"
                            class="collection-detail-empty-plus"
                            @click="() => $router.push('/admin/novo-video')"
                        />
                    </p>
                </div>
            </div>
        </div>

        <v-dialog v-model="showMoveDialog" max-width="600">
            <v-card>
                <v-card-title>Mover Vídeo</v-card-title>
                <button class="close-btn" @click="showMoveDialog = false">
                    <fa icon="fa-times" />
                </button>
                <v-card-text>
                    <div class="video-info">
                        <div class="video-thumbnail">
                            <img
                                :src="selectedVideo?.finalVideoThumbnail"
                                :alt="selectedVideo?.title"
                            />
                        </div>
                        <div class="video-details">
                            <h3>{{ selectedVideo?.title }}</h3>
                            <p class="duration">
                                Duração:
                                {{
                                    selectedVideo?.videoTime
                                        ? converterTempo(
                                              selectedVideo.videoTime
                                          )
                                        : '00:00'
                                }}
                            </p>
                        </div>
                    </div>

                    <div class="move-controls">
                        <p>Para qual coleção deseja mover este vídeo?</p>
                        <select
                            v-model="selectedCollection"
                            class="form-select"
                        >
                            <option value="">Selecione uma coleção</option>
                            <option
                                v-for="collection in collections"
                                :key="collection.id"
                                :value="collection.id"
                            >
                                {{ collection.name }} - {{ collection.id }}
                            </option>
                        </select>
                    </div>
                </v-card-text>
                <v-card-actions class="flex justify-end">
                    <v-spacer></v-spacer>

                    <v-btn color="primary" text @click="moveVideo">Mover</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div class="pa-4 text-center">
            <v-dialog v-model="deleteItem" max-width="320" persistent>
                <v-card>
                    <v-card-title class="headline">Atenção</v-card-title>

                    <v-card-text>
                        Deseja realmente excluir o vídeo {{ nameItem }}?
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="cancel" text @click="closeDialog"
                            >Não</v-btn
                        >
                        <v-btn class="accept" text @click="closeDialog"
                            >Sim</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        <Loader :hasReady="hasReady" />
        <NewSeason :showModal="showModal" @closeModalEmit="closeModal" />
    </div>
</template>

<script>
    import Sesson from '@/utils/Weflix/sesson';
    import Videos from '@/utils/Weflix/videos';
    import Loader from '@/components/Weflix/Loader.vue';
    import draggable from 'vuedraggable';
    import TitlePage from '@/components/Weflix/titlePage.vue';

    import { mapState } from 'vuex';

    export default {
        data() {
            return {
                seasson: [],
                valueProgressTemporary: 0,
                deleteItem: false,
                nameItem: '',
                season: '',
                seasonSelected: null,
                videos: [],
                hasReady: false,
                descriptionCollection: '',
                nameCollection: '',
                totalVideos: 0,
                totalMinutes: 0,
                totalViews: 0,
                dataViewVideos: [],
                manySeason: false,
                drag: false,
                isMobile: false,
                showMoveDialog: false,
                selectedVideo: null,
                selectedCollection: null,
                collections: [],
            };
        },
        components: {
            Loader,
            draggable,
            TitlePage,
        },
        computed: {
            ...mapState(['token', 'currentCollections']),
            collectionSubtitlePlain() {
                const raw = this.currentCollections?.shortDescription;
                if (!raw) {
                    return 'Gerencie os vídeos desta coleção no portal.';
                }
                return String(raw)
                    .replace(/<[^>]*>/g, '')
                    .replace(/\s+/g, ' ')
                    .trim();
            },
        },
        methods: {
            showOptions(element) {
                this.videos = this.videos.map((video) => ({
                    ...video,
                    showOptionsMenu:
                        video.id === element.id
                            ? !video.showOptionsMenu
                            : false,
                }));
            },
            getStatusClass(status) {
                const statusClasses = {
                    1: 'status-active',
                    0: 'status-inactive',
                    3: 'status-deleted',
                    4: 'status-error',
                    5: 'status-processing',
                };
                return statusClasses[status] || '';
            },
            getStatusText(status) {
                const statusTexts = {
                    1: 'Ativo',
                    0: 'Inativo',
                    3: 'Deletado',
                    4: 'Erro no Upload',
                    5: 'Processando',
                };
                return statusTexts[status] || 'Status Desconhecido';
            },
            deleteVideo(id, name) {
                this.deleteItem = true;
                this.nameItem = name;
            },
            closeDialog() {
                this.deleteItem = false;
            },
            openMoveDialog(element) {
                this.selectedVideo = element;
                this.showMoveDialog = true;
            },
            editVideo(id) {
                if (!this.drag) {
                    this.$router.push('/admin/video/' + id);
                }
            },
            async getSesson() {
                const param = this.$route.params.slug;
                try {
                    const response = await Sesson.getSessonByCollection(
                        this.token,
                        param
                    );

                    if (response.length > 0) {
                        this.season = response;
                        this.seasonSelected = this.season[0].id;
                        this.manySeason = this.season.length > 1;
                        this.getVideos(this.seasonSelected);
                    } else {
                        await this.newSeason();
                        const newResponse = await Sesson.getSessonByCollection(
                            this.token,
                            param
                        );
                        this.season = newResponse;
                        this.seasonSelected = this.season[0].id;
                        this.manySeason = this.season.length > 1;
                        this.getVideos(this.seasonSelected);
                    }
                } catch (error) {
                    console.error('Erro ao obter dados da coleção:', error);
                }
            },
            async getVideos(id) {
                try {
                    const response = await Videos.getVideosBySesson(
                        this.token,
                        id
                    );
                    // response.list = response.list.filter(video => video.status !== 3);
                    this.videos = response.list;
                    this.totalVideos = response.totalVideos;
                    this.totalMinutes = this.converterTempo(
                        response.totalVideoTime
                    );
                    this.totalViews = response.totalProgress;
                    this.dataViewVideos = response.progressDataMap;
                    this.hasReady = true;
                } catch (error) {
                    console.error('Erro ao obter dados dos Videos:', error);
                }
            },
            async newSeason() {
                const payload = {
                    idCourse: this.currentCollections.id,
                    title: 'Temporada 1',
                    sample: 0,
                };
                try {
                    const response = await Sesson.createSesson(
                        this.token,
                        payload
                    );
                    this.noSeason = false;
                    this.getSesson();
                } catch (error) {
                    console.error('Erro ao criar temporada:', error);
                }
            },
            converterTempo(segundos) {
                const horas = Math.floor(segundos / 3600);
                const minutos = Math.floor((segundos % 3600) / 60);

                const horasFormatadas = horas.toLocaleString('pt-BR');

                return horas > 0
                    ? `${horasFormatadas}h ${minutos}m`
                    : `${minutos}m`;
            },
            changeSeason() {
                this.hasReady = false;
                this.getVideos(this.seasonSelected);
            },
            async onDragEnd(evt) {
                this.drag = false;
                const newOrder = this.videos.map((video, index) => ({
                    id: video.id,
                    order: index + 1,
                }));
                try {
                    await Videos.orderVideos(this.token, newOrder);
                } catch (error) {
                    console.error('Erro ao atualizar ordem dos vídeos:', error);
                }
            },
            async moveVideo() {
                if (this.selectedCollection && this.selectedVideo) {
                    try {
                        const response = await Videos.moveVideo(
                            this.token,
                            this.selectedVideo.id,
                            this.selectedCollection
                        );
                        alert('Vídeo movido com sucesso');
                        this.showMoveDialog = false;
                        this.getVideos(this.seasonSelected);
                    } catch (error) {
                        console.error('Erro ao mover vídeo:', error);
                    }
                }
            },
            async getCollections() {
                try {
                    const response = await Videos.listCollections(this.token);
                    console.log(response);
                    this.collections = response.map((item) => ({
                        id: item.id,
                        name: item.name,
                        status: item.status,
                    }));
                } catch (error) {
                    console.error('Erro ao obter coleções:', error);
                }
            },
        },
        created() {
            this.isMobile = window.innerWidth <= 600;
            this.getSesson();
            this.getCollections();
        },
    };
</script>

<style scoped>
    @import url(./global.css);

    .collection-detail-page.weflix-admin-collection.page-card {
        background: #f4f5f8;
        border-radius: 16px;
        padding: 0 0 1rem;
        box-shadow: 0 1px 3px rgba(37, 8, 145, 0.06);
    }

    .collection-detail-header {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: space-between;
        gap: 1rem 1.5rem;
        padding: 1.25rem 1.5rem 1rem;
        background: linear-gradient(135deg, #fafbff 0%, #ffffff 100%);
        border-bottom: 1px solid #e8eaf0;
        border-radius: 16px 16px 0 0;
    }

    .collection-detail-header__lead {
        flex: 1;
        min-width: 200px;
    }

    .collection-detail-title-wrap {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        gap: 0.75rem 1rem;
    }

    .collection-detail-title-wrap :deep(.titlelayoutGeneric) {
        flex: 1;
        min-width: 180px;
        border-bottom: none;
        padding-bottom: 0;
    }

    .collection-detail-title-wrap :deep(.titlelayoutGeneric h3) {
        font-size: 1.5rem;
        margin: 0 0 0.35rem;
        color: #1a1d26;
    }

    .collection-detail-title-wrap :deep(.titlelayoutGeneric small) {
        display: block;
        color: #5c6370;
        line-height: 1.45;
    }

    .collection-detail-status-chip {
        font-weight: 600;
        flex-shrink: 0;
        margin-top: 0.2rem;
    }

    .collection-detail-header__actions {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 0.75rem;
    }

    .collection-detail-header-btn {
        min-height: 40px;
        font-weight: 600;
    }

    .collection-detail-header-btn--primary {
        box-shadow: 0 2px 8px rgba(37, 8, 145, 0.2);
    }

    @media (max-width: 768px) {
        .collection-detail-header__actions {
            width: 100%;
        }

        .collection-detail-header__actions .v-btn {
            flex: 1;
            min-width: 0;
        }
    }

    .collection-detail-shell {
        padding: 1.25rem 1.5rem 1.5rem;
        height: calc(100vh - 210px);
        overflow-y: auto;
        min-height: 0;
        box-sizing: border-box;
        scrollbar-width: none;
        -ms-overflow-style: none;
    }

    .collection-detail-shell::-webkit-scrollbar {
        display: none;
    }

    .collection-detail-stats {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 1rem;
        margin-bottom: 1.25rem;
    }

    @media (max-width: 767px) {
        .collection-detail-stats {
            grid-template-columns: 1fr;
        }
    }

    .collection-detail-stat-card {
        display: flex;
        align-items: center;
        gap: 1rem;
        padding: 1rem 1.25rem;
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    }

    .collection-detail-stat-card__icon {
        width: 44px;
        height: 44px;
        border-radius: 12px;
        background: #eef0fc;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .collection-detail-stat-card__icon :deep(svg) {
        color: #250891 !important;
        width: 1.25rem !important;
        height: 1.25rem !important;
    }

    .collection-detail-stat-card__body {
        display: flex;
        flex-direction: column;
        gap: 0.15rem;
        min-width: 0;
        text-align: left;
    }

    .collection-detail-stat-card__label {
        font-size: 0.75rem;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        color: #5c6370;
    }

    .collection-detail-stat-card__value {
        font-size: 1.35rem;
        font-weight: 700;
        color: #1a1d26;
        line-height: 1.2;
    }

    .collection-detail-list-panel {
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        padding: 1rem 1.25rem 1.25rem;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    }

    .collection-detail-order-hint.orderVideos {
        margin-bottom: 1rem;
        padding: 0 0 0.75rem;
        border-bottom: 1px solid #f0f2f5;
    }

    .collection-detail-order-hint small {
        color: #7a8190;
        font-size: 0.8125rem;
    }

    .collection-detail-empty-plus {
        cursor: pointer;
        color: #250891;
    }

    .collection-detail-no-videos.noVideos {
        text-align: center;
        padding: 2rem 1rem;
        color: #7a8190;
    }

    .collection-detail-no-videos.noVideos p {
        margin: 0;
    }
    div#addNewVideo button.btnWeflix {
        display: flex;
        align-items: center;
        transition: all 0.3s ease;
    }
    div#addNewVideo button.btnWeflix svg {
        color: #250891;
        transition: color 0.3s ease;
    }
    div#addNewVideo button.btnWeflix:hover svg {
        color: white;
    }
    .btnWeflix {
        right: 35px;
        transition: all 0.3s ease-in-out;
    }

    svg {
        width: auto;
    }

    .status-indicator {
        position: absolute;
        top: 0px;
        right: 70px;
        transition: all 0.2s ease;
    }

    .status-badge {
        padding: 4px 12px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 500;
        transition: all 0.3s ease;
    }

    .video-status {
        padding: 6px 12px;
        border-radius: 20px;
        font-size: 11px;
        margin-left: auto;
        font-weight: 600;
        position: absolute;
        bottom: 12px;
        right: 12px;
        transition: all 0.3s ease;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        z-index: 2;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    .status-active {
        background-color: #e6f4ea;
        color: #1e7e34;
    }

    .status-inactive {
        background-color: #feeced;
        color: #dc3545;
    }

    .status-deleted {
        background-color: #f8f9fa;
        color: #6c757d;
    }

    .status-error {
        background-color: #fff3cd;
        color: #856404;
        width: auto;
    }

    .status-processing {
        background-color: #cce5ff;
        color: #004085;
    }

    .drag-handle {
        cursor: move;
        margin-right: 12px;
        color: #b0b0b0;
        transition: all 0.3s ease;
        padding: 4px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .drag-handle:hover {
        color: #250891;
        background: #f0f0ff;
        transform: scale(1.1);
    }

    .drag-handle:active {
        transform: scale(0.95);
    }

    .CollectionVideos {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(20%, 1fr));
        gap: 20px;
        padding: 0;
        margin-top: 24px;
    }

    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
        transition: all 0.3s ease;
    }

    .drag {
        opacity: 0.8;
        transition: all 0.3s ease;
    }

    @media (max-width: 768px) {
        .CollectionVideos {
            grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
        }
    }
    .itemCollectionVideo {
        height: auto;
        background: white;
        border-radius: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        overflow: hidden;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        cursor: pointer;
        width: 100%;
        max-width: 100%;
        min-width: auto;
        animation: fadeIn 0.5s ease-in;
        border: 1px solid #f0f0f0;
        position: relative;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .itemCollectionVideo:hover {
        transform: translateY(-6px);
        box-shadow: 0 8px 24px rgb(14 1 70 / 37%);
    }

    .itemCollectionVideo-content {
        padding: 16px;
        display: flex;
        align-items: center;
        min-width: 0;
        transition: padding 0.3s ease;
        background: #fafbfc;
        border-bottom: 1px solid #f0f0f0;
    }
    .itemCollectionVideo p {
        color: #2c3e50;
        margin: 0;
        font-size: 13px;
        font-weight: 500;
        line-height: 1.4;
        transition: color 0.3s ease;
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .itemCollectionVideo-actions {
        position: relative;
        height: 180px;
        transition: all 0.3s ease;
        overflow: hidden;
    }

    .itemCollectionVideo-actions img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .itemCollectionVideo:hover .itemCollectionVideo-actions img {
        transform: scale(1.05);
    }

    .video-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
            to bottom,
            rgba(37, 8, 145, 0.4) 0%,
            rgba(37, 8, 145, 0.6) 100%
        );
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        backdrop-filter: blur(2px);
    }

    .video-overlay .video-overlay-icon :deep(svg) {
        width: 3rem !important;
        height: 3rem !important;
        color: #fff !important;
        transform: scale(0.7) translateY(10px);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
    }

    .itemCollectionVideo:hover .video-overlay {
        opacity: 1;
    }

    .itemCollectionVideo:hover .video-overlay .video-overlay-icon :deep(svg) {
        transform: scale(1) translateY(0);
    }

    .titleContainer {
        position: relative;
    }
    .titleContainer p {
        font-size: 13px;
        transition: font-size 0.3s ease;
    }
    .orderVideos {
        text-align: left;
        padding: 0 4px;
        margin-bottom: 10px;
        transition: padding 0.3s ease;
    }
    @media (min-width: 600px) {
        #addNewVideo .fa-video {
            display: none;
        }
    }
    @media (max-width: 600px) {
        div#addNewVideo button.btnWeflix {
            padding: 2px;
            width: 35px;
            height: 30px;
            transition: all 0.3s ease;
        }
        .weflix-admin-collection .status-indicator {
            position: absolute;
            top: -25px;
            right: 0;
            transition: all 0.3s ease;
        }
        .weflix-admin-collection .itemCollectionVideo {
            padding: 0;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
            min-width: auto;
        }
        .weflix-admin-collection .itemCollectionVideo-content {
            padding: 12px;
        }

        .itemCollectionVideo-actions {
            height: 160px;
        }

        .order-hint {
            padding: 8px 12px;
        }

        .order-hint small {
            font-size: 12px;
        }
    }

    .video-options {
        position: absolute;
        right: 10px;
        top: 20px;
        text-align: end;
        transition: all 0.3s ease;
    }
    .options-menu {
        width: auto;
        background-color: #f0f0f0;
        padding: 5px 20px;
        position: relative;
        z-index: 10;
        margin-top: 5px;
        transform: translateX(-14px);
        transition: all 0.3s ease;
    }
    .options-menu:hover {
        background-color: #e0e0e0;
    }
    button.close-btn {
        position: absolute;
        top: 25px;
        right: 10px;
        transition: all 0.3s ease;
    }
    button.close-btn svg.svg-inline--fa.fa-xmark {
        color: #20237a;
        transition: color 0.3s ease;
    }
</style>
<style>
    button.close-btn > .v-card-actions {
        padding: 0px 25px !important;
    }
</style>
